module.exports = "input {\n  font-size: 15px; }\n\nh1 {\n  color: #369;\n  font-family: Arial, Helvetica, sans-serif;\n  font-weight: bold; }\n\n.container {\n  text-align: center;\n  margin-top: 50px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/componentes/home/home.component.scss
// module id = ./src/app/componentes/home/home.component.scss
// module chunks = main